import { render } from "./ExamTypeList.vue?vue&type=template&id=86e409ac"
import script from "./ExamTypeList.vue?vue&type=script&lang=js"
export * from "./ExamTypeList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__